import { FC, useCallback } from "react";
import { Button, Stack, Typography } from "@mui/material";
import CollectingDataImage from "@/assets/empty-states/collecting_provider_connection_date_state.png";
import { setActiveProviderConnectionType } from "@/store/provider-connections/providerConnectionsSlice";
import { useAppDispatch } from "@/store/hooks";

export const SnowflakeConnectionCollectingData: FC = () => {
  const dispatch = useAppDispatch();

  const closeDrawerHandler = useCallback(() => {
    dispatch(setActiveProviderConnectionType(null));
  }, [dispatch]);

  return (
    <Stack p={2} spacing={3} alignItems="center">
      <Typography>
        Collecting data. This process can take up to 24 hours.
      </Typography>
      <img
        height={200}
        width={286}
        src={CollectingDataImage}
        alt="Collecting Data"
      />
      <Button
        onClick={closeDrawerHandler}
        variant="outlined"
        sx={{ alignSelf: "end" }}
      >
        Close
      </Button>
    </Stack>
  );
};
